module.exports = __webpack_public_path__ + "static/img/smk_icon.png";